export const PRESET_COLORS = [
  '#ffa500',
  '#004096',
  '#1d92ff',
  '#c8102e',
  '#01f8d5',
  '#f96a66',
  '#f6ffac',
  '#3bca52',
  '#94e4ff',
];

export default PRESET_COLORS;
